<div class="container document-container">
  <div class="content">
    <div class="wrap">
      <div class="text-center mt-4">
        <h3>{{ 'documentList.header' | translate }}</h3>
      </div>
      <div class="row justify-content-center mb-3" *ngIf="!errorMessage">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <div class="row" *ngFor="let documentType of documentList">
            <div *ngIf="documentType.documentDetail.length" class="col-12 mt-2">
              <h5>{{ documentType.docTypeDescription }}&nbsp;({{ documentType.documentDetail.length }})</h5>
            </div>
            <div class="col-12" *ngFor="let document of documentType.documentDetail">
              <button
                class="btn btn-outline-secondary btn-block text-left mb-2 btn-download-policy"
                (click)="openDocument(document.epolicyId)"
              >
                <span class="text-dark">{{ 'documentList.policyNo' | translate }}&nbsp;{{ document.policyNo }}</span
                ><br />
                <small>{{ document.message }}</small
                ><br />
                <small *ngIf="!isClaimNotiDocType(documentType.docType)">{{ 'documentList.expiryDate' | translate }}&nbsp;{{ document.expiredDate }}</small>
                <small *ngIf="isClaimNotiDocType(documentType.docType)">{{ 'documentList.claimNotiDate' | translate }}&nbsp;{{ document.claimNotiDate }}</small>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center text-danger mb-3" *ngIf="errorMessage">
      <h5 [innerHTML]="errorMessage | translate"></h5>
    </div>
    <app-footer-azay-logo></app-footer-azay-logo>

    <div class="text-login">
      <span>{{ 'otp.lastSuccessLogin' | translate }}:&nbsp;{{ successLoginTime || '-' }}</span
      ><br />
      <div *ngIf="hasFailedLogin">
        <span>{{ 'otp.lastFailLogin' | translate }}:</span>
        <table class="table table-bordered table-sm">
          <tr *ngFor="let failInfo of failLoginList">
            <td>{{ failInfo.loginDateTime }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</div>
<ngx-loading [show]="isLoading"></ngx-loading>
